const KEY_ALT_DOWN_COPY = 'KEY_ALT_DOWN_COPY'
const KEY_ALT_DOWN_COPY_VALUE = 'KEY_ALT_DOWN_COPY_VALUE'
const state = {
  keyAltDownCopy: false,
  keyAltDownCopyVal: '',
}

const mutations = {
  [KEY_ALT_DOWN_COPY]: (state, value) => {
    state.keyAltDownCopy = value
  },
  [KEY_ALT_DOWN_COPY_VALUE]: (state, value) => {
    state.keyAltDownCopyVal = value
  }
}

const actions = {
  setKeyAltDownCopy({ commit }, val) {
    commit(KEY_ALT_DOWN_COPY, val)
  },
  setKeyAltDownCopyVal({ commit }, val) {
    commit(KEY_ALT_DOWN_COPY_VALUE, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
